/**
 * External Dependencies
 */
import $ from 'jquery';
import 'select2';
import Swiper from 'swiper/swiper-bundle.esm.js';
import hcSticky from 'hc-sticky';
import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from "splitting";
import '@fancyapps/fancybox';
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

$(document).ready(() => {

});

gsap.registerPlugin(ScrollTrigger);

Splitting();
var featuresSlider;
var mobileEffect = $(window).width() < 768;

function resizeCheck() {

  mobileEffect = $(window).width() < 768;

  $('[data-style]:visible').each(function(){
    var cur = $(this);
    cur.attr('style', cur.attr('data-style')).removeAttr('data-style');
  })
}

function lazyload() {

  var scrollTop = $(window).scrollTop();
  if ($('.features-slider.swiper-container-initialized').length && featuresSlider) {
    $('.features-slider').each(function() {
      var offset = $('.scroll-wrap').offset().top + $(window).height()/2;
      var height = $('.scroll-wrap').height() - $(window).height()/2;
      var per = (scrollTop + $(window).height() - offset) / (height);
      if (per > -.5 && per < 1.5 ) {
        var length = $(this).find('.swiper-slide').length;
        featuresSlider.slideTo(Math.round(per *length)-1)
      }
    });
  }

  var half = parseInt($('.hero-part').height()/(mobileEffect ? 4 : 4));
  if (scrollTop <= half) {
    $('.hero-content').addClass('fixed').removeClass('absolute').css({ top: 0 });
  } else {
    $('.hero-content').removeClass('fixed').addClass('absolute').css({ top: half });
  }
};

function setEffectLoad(selector) {
  var halfW = $(window).height();
  $(selector+':not(.loaded)').each(function(index) {

    var elem = this;
    var chars = [$(elem).find('[data-splitting]:not([data-anim-disabled]) .word > .char, .whitespace')];
    var set = $(elem).find('.prose:not([data-anim-disabled])');
    if (set.length) {
      chars.push(set);
    }
    var delay = ($(this).attr('data-effect') && parseFloat($(this).attr('data-effect'))) ? $(this).attr('data-effect') : 0;
    var timelineSettings = {
      staggerValue: 0.006,
      charsDuration: .8
    };


    var anim = gsap.timeline({
      onUpdate: self => {
        if ($(elem).attr('data-effect') == 'line') {
          $(elem).parent().addClass('parent-l')
        }
      }
    })
      .staggerFromTo( chars, timelineSettings.charsDuration, {
        ease: 'none',
        opacity: 0,
        delay: 0,
        y: '100%'
      },{
        ease: 'Power2.easeOut',
        opacity: 1,
        delay: delay,
        y: '0%'
      }, timelineSettings.staggerValue, 'switchtime')
    anim.pause();
    ScrollTrigger.create({
      trigger: elem,
      onLeave: () => {
        $(elem).parent().removeClass('parent-l')
      },
      onLeaveBack: () => {
        $(elem).parent().removeClass('parent-l')
      },
      onEnter: () => {
        $(elem).parent().removeClass('parent-l')
        anim.pause(0);
        anim.play()
      },
      onEnterBack: () => {
        $(elem).parent().removeClass('parent-l')
        anim.pause(0);
        anim.play()
      },
    });
  });
};

var indd = 0;
function setEffectLoadSlider(selector) {
  var halfW = $(window).height();
  var allTimes = [];
  $(selector).each(function(index) {

    indd++;
    for (var i = 0; i < (+indd+1); i++) {
      if (window['s'+i]) {
        window['s'+i].time(0).kill();
      }
    }

    var elem = this;
    var chars = [$(elem).find('[data-splitting]:not([data-anim-disabled]) .word > .char, .whitespace')];
    var set = $(elem).find('.prose:not([data-anim-disabled])');
    if (set.length) {
      chars.push(set);
    }
    var delay = ($(this).attr('data-effect') && parseFloat($(this).attr('data-effect'))) ? $(this).attr('data-effect') : 0;
    var timelineSettings = {
      staggerValue: 0.006,
      charsDuration: .8
    };

    window['s'+indd] = gsap
      .timeline({
        onUpdate: self => {
          if ($(elem).attr('data-effect') == 'line') {
            $(elem).parent().addClass('parent-l')
          }
        }
      })
      .staggerTo( chars, timelineSettings.charsDuration, {
        ease: 'Power2.easeOut',
        opacity: 1,
        delay: delay,
        y: '0%'
      }, timelineSettings.staggerValue, 'switchtime');
  });
};


function setEffectLoadInit(selector) {
  $(selector+':not(.used)').each(function() {
    $(this).addClass('used')
    $(this).addClass('show')
    var chars = $(this).find('[data-splitting]:not([data-anim-disabled]) .word > .char, .whitespace');
    var set = $(this).find('.prose:not([data-anim-disabled])');

    var time = gsap.timeline();
    if (chars.length) {
      time.set(chars, {
        opacity: 0,
        y: '100%'
      }, 'switchtime')
    }
    if (set.length) {
      time.set(set, {
        opacity: 0,
        y: '15rem'
      }, 'switchtime')
    }
  });
};

$(document).ready(function () {

  document.addEventListener( 'wpcf7mailsent', function( event ) {

    setTimeout(function() {
      $('body').addClass('wpcf7-success');
    }, 100);

    $('html, body').animate({
      scrollTop: $("#form-section").offset().top
    }, 50);

  }, false );

  $('select.form-select.field-country').select2({
    maximumSelectionLength: 1,
    placeholder: app.cf7_country,
  }).on("select2:open", function () {
    if (mobileEffect) {
      $('textarea').blur();
    }
  });

  $('select.form-select.field-role').select2({
    maximumSelectionLength: 1,
    placeholder: app.cf7_role,
  }).on("select2:open", function () {
    if (mobileEffect) {
      $('textarea').blur();
    }
  });

  if ($(".js-small-zoomout").length) {
    gsap.timeline({
      scrollTrigger: {
        trigger: ".js-small-zoomout",
        start: "top top",
        end: "center top",
        scrub: true
      }
    }).from('.js-small-zoomout', {
      scale: 1.1,
      ease: 'none'
    })
  };

  if ($(".hero-part").length) {
    gsap.timeline({
      scrollTrigger: {
        trigger: ".hero-part",
        start: "-center top",
        end: "center top",
        scrub: true
      }
    }).to('.js-top-overlay', {
      opacity: .2,
      ease: 'none'
    })

    gsap.timeline({
      scrollTrigger: {
        trigger: ".hero-part",
        scrub: !mobileEffect
      }
    }).to('.js-top-bg', {
      y: mobileEffect ? '-13%' : '-11%',
      scale: 1,
      ease: 'none'
    })
  }

  if ($("[data-float]").length) {
    gsap.timeline({
      scrollTrigger: {
        trigger: '[data-float]',
        start: "-=500",
        end: "+=500",
        scrub: true
      }
    }).to('[data-float]', {
      y: '-10%',
      scale: 1,
      ease: 'none'
    })
  }

  new Swiper('.quotes-slider', {
    slidesPerView: 'auto',
    spaceBetween: 25,
    navigation: {
      nextEl: '.quotes-slider .swiper-button-next',
      prevEl: '.quotes-slider .swiper-button-prev',
    },
  })

  new Swiper('.blog-slider', {
    slidesPerView: 'auto',
    spaceBetween: 25,
    navigation: {
      nextEl: '.blog-slider .swiper-button-next',
      prevEl: '.blog-slider .swiper-button-prev',
    },

    breakpoints: {
      1200: {
        spaceBetween: 25,
      },
      320: {
        spaceBetween: 15
      }
    },
  })

  $(document).on('click', '.menu-trigger', function () {
    $('body').toggleClass('active-menu');
    return false;
  });

  $(document).on('click', '.faq-item .faq-trigger', function () {
    if ($(this).hasClass('active')) {
      $('.faq-item .faq-trigger').removeClass('active');
      $('.faq-item .faq-content').addClass('hidden');
    } else {
      $('.faq-item .faq-trigger').removeClass('active');
      $('.faq-item .faq-content').addClass('hidden');
      $(this).addClass('active').next().removeClass('hidden');
    };
    return false;
  });

  $('.scroll-wrap').each(function() {
    $(this).height('calc(50vh * '+(+$(this).find('.swiper-slide').length)+')')
  });
  if (!$('.features-slider.swiper-container-initialized').length) {

    featuresSlider = new Swiper('.features-slider', {
      loop: false,
      effect: 'fade',
      allowTouchMove: false,
      fadeEffect: {
        crossFade: true
      },
      autoHeight: true,
      lazy: {
        loadPrevNext: true,
      },
    });

    featuresSlider.on('slideChangeTransitionEnd', function () {
      setEffectLoadSlider('.features-slider .swiper-slide-active [data-effect-man]');
    });
    $('body').addClass('mobile-v');
  }
  resizeCheck();
  $(window).on('resize', function() {
    resizeCheck();
    lazyload();
  });
  $(window).on('scroll', function() {
    lazyload();
  });

  $(window).on('load', function() {
    window.setTimeout(function() {
      lazyload();
    }, 100);

  });

  setEffectLoadInit('[data-effect]');
  setEffectLoadInit('.features-slider [data-effect-man]');
  setEffectLoad('[data-effect]');

  // Video play

  $(document).on('click', '.js-play', function (e) {

    if ($(".js-video").get(0).paused) {
      $(this).fadeOut(500);
      $(".js-video").trigger('play');

    } else {
      $(".js-video").trigger('pause');
      $(this).fadeIn(500);
    }
  });

  $(document).on('click', '.js-video', function (e) {

    $(".js-video").trigger('pause');
    $(".js-play").show();
  });

  // Fancybox modal
  jQuery("[data-fancybox]").fancybox({
    touch: false,

    helpers : {
      overlay : {
        css : {
          'display' : 'inline-block',
        }
      }
    }
  });
});
